import { Component } from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'amd-dropzone',
    templateUrl: 'dropzone.component.html'
})

export class DropzoneComponent {

    constructor() { }
}
